import type { TUser } from "@/api/user";
import { AbilityBuilder, createMongoAbility, type MongoAbility } from "@casl/ability";

export enum ActionsEnum {
  USE = "USE",
  VIEW = "VIEW",
  VIEW_ANY = "VIEW_ANY",
  VIEW_DEALER = "VIEW_DEALER",
  CREATE = "CREATE",
  CREATE_ANY = "CREATE_ANY",
  CREATE_DEALER = "CREATE_DEALER",
  EDIT = "EDIT",
  EDIT_ANY = "EDIT_ANY",
  EDIT_DEALER = "EDIT_DEALER",
  DELETE = "DELETE",
  DELETE_ANY = "DELETE_ANY",
  DELETE_DEALER = "DELETE_DEALER",
}

export enum SubjectsEnum {
  IS = "IS",
  SYSTEM = "SYSTEM",
  USER = "USER",
  FAMILY = "FAMILY",
  CHILD = "CHILD",
  DEVICE = "DEVICE",
  DEALER = "DEALER",
  LICENSE = "LICENSE",
  SERVICE = "SERVICE",
  SERVICE_TYPE = "SERVICE_TYPE",
  ROLE = "ROLE",
  REGION = "REGION",
}

export type Actions = keyof typeof ActionsEnum;
export type Subjects = keyof typeof SubjectsEnum;

export type AppAbility = MongoAbility<[Actions, Subjects]>;

export const ability = createMongoAbility<AppAbility>();

function defineRulesFor(user: TUser) {
  const { can, cannot, rules } = new AbilityBuilder<AppAbility>(createMongoAbility);

  user.privileges.forEach(privilege => {
    const [action, subject] = privilege.split("_");

    if (action === ActionsEnum.USE) {
      can(action as Actions, subject as Subjects);
      return;
    }

    if (String(action) === "SUPERADMIN") {
      can(ActionsEnum.USE, Object.values(SubjectsEnum));
    }

    if (SubjectsEnum[subject as Subjects]) {
      can(action as Actions, Object.values(SubjectsEnum));
    } else {
      can(action as Actions, Object.values(SubjectsEnum));
      can(privilege as Actions, Object.values(SubjectsEnum));
    }
  });

  if (user.dealer_locked) {
    cannot(ActionsEnum.CREATE, Object.values(SubjectsEnum));
    cannot(ActionsEnum.EDIT, Object.values(SubjectsEnum));
    cannot(ActionsEnum.DELETE, Object.values(SubjectsEnum));
  }

  return rules;
}

export function updateAbility(user: TUser) {
  console.log("Updating ability for user", user);
  ability.update(defineRulesFor(user));
}
